import type { FrontendWidget } from '../types';
import { LocationFinderComponent } from './LocationFinderComponent';
import type { LocationFinderConfig, LocationFinderResolved } from './types';

export const locationFinderWidget: FrontendWidget<
  LocationFinderConfig,
  LocationFinderResolved
> = {
  componentType: 'widgets.location-finder',
  displayName: 'Location Finder',
  ComponentA: LocationFinderComponent,
  resolveSync: (config) => config,
};
